export const SUCCESS_PAGE_POPUP_CLOSED = {
    action: 'pop up closed',
    category: 'Thank you page upsell',
    label: 'timer was restarted',
    name: 'GAEventGenericTrigger',
};
